
export default {
  title: "服务条款",
  subtitle: "请仔细阅读以下条款，使用我们的服务即表示您同意这些条款",
  lastUpdated: "最后更新：2024年1月15日",
  // 使用单引号包裹整体字符串，内部的双引号保持原样，避免语法错误
  intro: '欢迎使用Deriway支付服务。本服务条款（"条款"）构成您与Deriway之间具有法律约束力的协议。',
  
  section1: {
    title: "1. 服务描述",
    intro: "Deriway提供以下支付收单服务：",
    item1: "• 在线支付收单和处理服务",
    item2: "• 多渠道支付接入（信用卡、借记卡、电子钱包等）",
    item3: "• 跨境支付和货币兑换服务",
    item4: "• 资金清算和结算服务",
    item5: "• 支付数据分析和风控服务"
  },
  
  section2: {
    title: "2. 商户资格",
    intro: "使用我们的收单服务，您必须：",
    item1: "• 是合法注册的企业或个体工商户",
    item2: "• 提供真实、准确、完整的商户信息和资质文件",
    item3: "• 从事合法的商业活动",
    item4: "• 不属于我们服务限制的行业或地区",
    item5: "• 通过我们的商户审核和合规检查"
  },
  
  section3: {
    title: "3. 账户管理",
    registration: "账户注册：您需要完成商户入驻和资质审核才能使用收单服务",
    security: "账户安全：您有责任保护商户账户安全，包括API密钥和支付密码",
    responsibility: "账户责任：您对账户下的所有交易和操作负责",
    suspension: "账户暂停：当发现违规或风险时，我们有权暂停或关闭您的商户账户"
  },
  
  section4: {
    title: "4. 支付处理规则",
    intro: "使用支付服务时，您同意：",
    item1: "• 遵守支付行业标准和我们的交易规则",
    item2: "• 确保交易的真实性和合法性",
    item3: "• 配合处理退款、争议和拒付",
    item4: "• 不从事欺诈交易或洗钱活动",
    item5: "• 接受我们的风控措施和交易监控"
  },
  
  section5: {
    title: "5. 费用和结算",
    intro: "我们的费用结构如下：",
    trading: "• 交易手续费：按交易金额的百分比收取",
    withdrawal: "• 提现费用：根据提现方式和金额收取",
    management: "• 服务费用：账户维护和技术服务费",
    other: "• 其他费用：退款处理费、争议处理费等",
    notice: "• 结算周期：T+1或T+7，以合同约定为准"
  },
  
  section6: {
    title: "6. 风险提示",
    intro: "支付收单业务涉及以下风险：",
    market: "• 拒付风险：持卡人可能发起拒付申请",
    liquidity: "• 资金风险：可能面临资金冻结或扣留",
    credit: "• 信用风险：交易对手违约或欺诈",
    operational: "• 技术风险：系统故障可能影响交易处理",
    regulatory: "• 合规风险：监管政策变化的影响"
  },
  
  section7: {
    title: "7. 合规义务",
    intro: "您必须遵守以下合规要求：",
    kyc: "• 配合完成商户尽职调查（KYB）程序",
    aml: "• 遵守反洗钱和反恐怖主义融资规定",
    reporting: "• 如实申报交易信息和税务材料",
    sanctions: "• 不与制裁名单中的个人或实体交易",
    laws: "• 遵守支付行业法规和监管要求"
  },
  
  section8: {
    title: "8. 服务限制",
    intro: "我们保留以下权利：",
    item1: "• 拒绝处理可疑或高风险交易",
    item2: "• 对违规商户暂停或终止服务",
    item3: "• 调整费率和服务条件",
    item4: "• 在紧急情况下冻结资金或账户",
    item5: "• 配合监管部门和执法机构调查"
  },
  
  section9: {
    title: "9. 责任限制",
    intro: "在法律允许的最大范围内：",
    item1: "• 我们不承担间接损失或利润损失责任",
    item2: "• 我们的赔偿责任不超过争议交易金额",
    item3: "• 我们不保证支付服务的绝对稳定性",
    item4: "• 您承认支付业务存在固有风险",
    item5: "• 不可抗力事件免除我们的责任"
  },
  
  section10: {
    title: "10. 争议解决",
    intro: "发生争议时：",
    negotiation: "• 首先通过客服渠道协商解决",
    arbitration: "• 协商不成可申请第三方调解",
    costs: "• 争议处理费用按责任比例承担"
  },
  
  section11: {
    title: "11. 条款修改",
    intro: "我们可能修改这些条款：",
    item1: "• 重大修改将提前30天书面通知",
    item2: "• 继续使用服务视为接受修改",
    item3: "• 不同意修改者可终止服务协议",
    item4: "• 修改后的条款对所有商户生效"
  },
  
  section12: {
    title: "12. 联系方式",
    intro: "如有疑问或需要支持，请联系我们：",
    email: "• 客服邮箱：support@deriway.com",
    telegram: "• 商务合作：@deriway_business",
    hours: "• 服务时间：工作日9:00-18:00",
    response: "• 我们将在24小时内回复您的咨询"
  }
};
